import {createContext} from 'react';
import {IWineShop} from 'modules/wineshops-list/models';

export interface IReservationModalContext {
    openWineryPicker: (wineShopList: IWineShop[], onSelectShop: (wineshop: IWineShop) => void) => void;
    openReserveModal: (code: string, wineshop: IWineShop) => void;
}

export const ReservationModalContext = createContext<IReservationModalContext>({
    openWineryPicker: () => {},
    openReserveModal: () => {},
});
